import * as yup from "yup";
import { createValidationSchema, validate } from "@";
import type {
  ResendCodeFormValues,
  UpdateSmsSendingDateFormValues,
  UpdateStatusFormValues,
} from "../types.ts";

// ============================================
// Update Status Validation Schema
// ============================================

export const updateStatusSchema = createValidationSchema({
  verificationStagesIds: validate("array"),
  comment: yup.string().when(["isAccepted"], {
    is: false,
    then: () => validate("req"),
    otherwise: () => yup.string().nullable().label("comment"),
  }),
});

export const updateStatusDefaultValues: UpdateStatusFormValues = {
  verificationStagesIds: [],
  isAccepted: false,
  comment: "",
};

// ============================================
// Resend Code Validation Schema
// ============================================

export const resendCodeSchema = createValidationSchema({
  fromTime: validate("date"),
  toTime: validate("date"),
});

export const resendCodeDefaultValues: ResendCodeFormValues = {
  fromTime: null,
  toTime: null,
};

// ============================================
// Update SMS Sending Date Validation Schema
// ============================================

export const updateSmsSendingDateSchema = createValidationSchema({
  dateToSendSmsNotification: validate("date"),
});

export const updateSmsSendingDateDefaultValues: UpdateSmsSendingDateFormValues =
  {
    dateToSendSmsNotification: null,
  };
